"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshRefreshToken = exports.getRefreshTokenWithEmailPass = exports.getAccessTokenWithRefreshToken = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _jsTools = require("@airportlabs/js-tools");
var graphqlMiddlewareUrl = (0, _jsTools.getEnv)("REACT_APP_GRAPHQL_MIDDLEWARE_URL");
var fetchTokenMutation = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(query, input, mutationName) {
    var _resultJSON$data, _resultJSON$errors;
    var result, resultJSON;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetch(graphqlMiddlewareUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify({
              query: query,
              variables: {
                input: input
              }
            })
          });
        case 2:
          result = _context.sent;
          _context.next = 5;
          return result.json();
        case 5:
          resultJSON = _context.sent;
          return _context.abrupt("return", {
            data: (_resultJSON$data = resultJSON.data) === null || _resultJSON$data === void 0 ? void 0 : _resultJSON$data[mutationName],
            error: (_resultJSON$errors = resultJSON.errors) === null || _resultJSON$errors === void 0 ? void 0 : _resultJSON$errors[0]
          });
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchTokenMutation(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var getAccessTokenWithRefreshToken = exports.getAccessTokenWithRefreshToken = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2) {
    var refreshToken, mutationName, mutation;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          refreshToken = _ref2.refreshToken;
          mutationName = "getAccessToken";
          mutation = "mutation GetAccessToken($input: GetAccessTokenInput!) {\n    ".concat(mutationName, "(in: $input) {\n      token\n    }\n  }");
          _context2.next = 5;
          return fetchTokenMutation(mutation, {
            refreshToken: refreshToken
          }, mutationName);
        case 5:
          return _context2.abrupt("return", _context2.sent);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getAccessTokenWithRefreshToken(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
var getRefreshTokenWithEmailPass = exports.getRefreshTokenWithEmailPass = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref4) {
    var email, password, mutationName, mutation;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          email = _ref4.email, password = _ref4.password;
          mutationName = "getRefreshTokenEmailPass";
          mutation = "mutation GetRefreshTokenEmailPass($input: GetRefreshTokenEmailPassInput!) {\n    ".concat(mutationName, "(in: $input) {\n      token\n      redirectLink\n    }\n  }");
          _context3.next = 5;
          return fetchTokenMutation(mutation, {
            email: email,
            password: password
          }, mutationName);
        case 5:
          return _context3.abrupt("return", _context3.sent);
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getRefreshTokenWithEmailPass(_x5) {
    return _ref5.apply(this, arguments);
  };
}();
var refreshRefreshToken = exports.refreshRefreshToken = /*#__PURE__*/function () {
  var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref6) {
    var refreshToken, mutationName, mutation;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          refreshToken = _ref6.refreshToken;
          mutationName = "refreshRefreshToken";
          mutation = "mutation RefreshRefreshToken($input: RefreshRefreshTokenInput!) {\n    ".concat(mutationName, "(in: $input) {\n      token\n    }\n  }");
          _context4.next = 5;
          return fetchTokenMutation(mutation, {
            refreshToken: refreshToken
          }, mutationName);
        case 5:
          return _context4.abrupt("return", _context4.sent);
        case 6:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function refreshRefreshToken(_x6) {
    return _ref7.apply(this, arguments);
  };
}();